import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import LdapGroupMappingGrid from './ldapGroupMappingGrid';

@inject('translationsStore', 'rootLdapStore', 'ldapTeamMappingStore') @observer
export default class LdapGroupMappingContainer extends Component {
  
    buildModel = () => {

        this.props.ldapTeamMappingStore.ldapTeamMappings.map((item) => {

            item.serverName = this.props.rootLdapStore.ldapServers.filter((s) => s.id == item.ldapServerId)[0].name;
        });
    }

    render() {
  
        if (this.props.ldapTeamMappingStore.ldapTeamMappings === undefined
                || this.props.rootLdapStore.ldapServers === undefined) {
            
            return null;
        }

        this.buildModel();

        const translations = {
            ldapServer: this.props.translationsStore.translate('LDAP_SERVER'),
            group: this.props.translationsStore.translate('GROUP'),
            groupDn: this.props.translationsStore.translate('GROUP_DN')
        };

        return (
            <div>
                <LdapGroupMappingGrid 
                    translationsStore={this.props.translationsStore}
                    ldapTeamMappings={this.props.ldapTeamMappingStore.ldapTeamMappings}
                    translations={translations}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/teams/ldapGroupMapping/index.jsx